import { render, staticRenderFns } from "./COMBINE.vue?vue&type=template&id=27649d02&"
import script from "./COMBINE.vue?vue&type=script&lang=js&"
export * from "./COMBINE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports